import { redirect, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetVoucherTopPageParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MARKETING.VOUCHER.TOP>>();

	if (!hotelID) {
		redirect("/");
	}

	return { hotelID: hotelID! };
};
